/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Type/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Type({
  children,
  viewPath = "/DesignSystem/PatientInformation/Content/AppointmentBooking/Content/Booking/Type"
  
}) {
let patientBookingAppointmentTypeDisplayNameValueData = fromData.useDataValue({ viewPath,
context: 'patient',
path: 'booking.appointment.type.display_name',
})
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral900}
 weight="medium"
 data="patient.booking.appointment.type.display_name"
 text={patientBookingAppointmentTypeDisplayNameValueData}
 size="small"
/>
{children}
</React.Fragment>)
}